<template>
    <div class="layout-wrapper"
         v-if="value.LayoutID"
         :key="value.LayoutID">
        <CollapseWrapper
            v-for="setting in settings"
            class="mb-3"
            :key="setting.key"
            v-bind="setting"
        >
            <div v-for="group in groupedParameters(setting.group)" :key="group.LayoutParameterValueID">
                <component
                    v-if="group.ParameterTypeName !== 'DashboardLogo' && group.ParameterTypeName !== 'FaviconIcon'"
                    v-bind="group"
                    :is="group.ParameterTypeName"
                    v-model="group.Value"
                />
                <logo
                    v-else
                    v-bind="group"
                    v-model="group.ValueText"
                />
            </div>
        </CollapseWrapper>
    </div>
</template>
<script>
    import { mapOrder } from '@/helpers/util'
    import ColorParameterType from '../components/ColorParameterType'
    import ImageParameterType from '../components/ImageParameterType'
    import NumberParameterType from '../components/NumberParameterType'
    import BooleanParameterType from '../components/BooleanParameterType'
    import IntervalParameterType from '../components/IntervalParameterType'
    import SingleSoundSelectorParameterType from '../components/SingleSoundSelectorParameterType'
    import { DEFAULT_GROUP_KEYS } from '../layout-management'

    export default {
        inheritAttrs: false,
        components: {
            CollapseWrapper: () => import('@/views/common/CollapseWrapper'),
            [ColorParameterType.name]: ColorParameterType,
            [ImageParameterType.name]: ImageParameterType,
            [BooleanParameterType.name]: BooleanParameterType,
            [NumberParameterType.name]: NumberParameterType,
            [IntervalParameterType.name]: IntervalParameterType,
            [SingleSoundSelectorParameterType.name]: SingleSoundSelectorParameterType
        },
        props: {
            value: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                groupKeys: DEFAULT_GROUP_KEYS,
                settings: [
                    {
                        key: 1,
                        title: 'layout.config.title.general',
                        icon: 'IconColorSettings',
                        group: 'General',
                    },
                    {
                        key: 2,
                        title: 'layout.config.title.widgets',
                        icon: 'IconColorSettings',
                        group: 'Widgets',
                    },
                    {
                        key: 3,
                        title: 'layout.config.title.indicatorsColors',
                        icon: 'IconColorSettings',
                        group: 'IndicatorsColors',  
                    },
                    {
                        key: 4,
                        title: 'layout.config.title.textSettings',
                        icon: 'IconTextSettings',
                        group: 'Fonts',
                    },
                    {
                        key: 5,
                        title: 'layout.config.title.timerSettings',
                        icon: 'IconTimerSettings',
                        group: 'Timers',
                    },
                ],
            }
        },
        methods: {
            groupedParameters(section) {
                const group = this.groupKeys[section]
                const settings = this.value.LayoutParametersList
                    .filter((el) => group.includes(el.LayoutParameterName) && el.LayoutParameterName !== 'ColorWidgetGroupFrames' && el.LayoutParameterName !== 'ColorWidgetGroupBackground')
                // TODO: need to add opportunities to change keys: ColorWidgetGroupFrames, ColorWidgetGroupBackground
                return mapOrder(settings, group, 'LayoutParameterName')
            }
        },
    }
</script>
<style lang="scss">
.rtl {
    .layout-wrapper /deep/ {

        .el-button--primary {
            margin-left: 10px;
        }

        .el-button--default {
            margin-left: 10px;
        }
    }
}
</style>
